import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import PortalBackground from '../../components/PortalBackground';
import ProgramDetail, { CUSTOM_PROGRAM, CUSTOM_TIER } from '../ProgramDetail';

// CRM-side custom program builder: the same ProgramDetail builder a client uses on
// /start/programdetail, started on "Custom".
const CustomProgramBuilder = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen py-8 px-4 md:px-6 relative">
      <PortalBackground />
      <div className="relative max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <button
            onClick={() => navigate('/crm/programs-template')}
            title="Back to Programs Template"
            aria-label="Back to Programs Template"
            className="inline-flex items-center justify-center w-10 h-10 text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-full hover:bg-gray-50 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-white transition-colors"
          >
            <FaArrowLeft className="h-4 w-4" />
          </button>
          <h1 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white text-center">
            Custom Programs
          </h1>
          <div className="w-10" />
        </div>

        <ProgramDetail
          embedded={true}
          selectedProgramProp={CUSTOM_PROGRAM}
          selectedTierProp={CUSTOM_TIER}
          hideActionButton={true}
          hideHeader={true}
        />
      </div>
    </div>
  );
};

export default CustomProgramBuilder;
